export const compareStrings = (a: string, b: string) => {
  return a.localeCompare(b);
};

export const compareDateStrings = (a: string, b: string) => {
  return new Date(a).getTime() - new Date(b).getTime();
};

export const compareNumbers = (a: number, b: number) => {
  return a - b;
};

type CompareStartDateProps = {
  startDate: string;
};

/**
 * Compare two objects that have `startDate`. Empty/null/undefined comes first.
 */
export const compareStartDate = (
  a: CompareStartDateProps,
  b: CompareStartDateProps,
) => {
  if (!a.startDate) {
    return 1;
  }
  return a.startDate > b.startDate ? 1 : -1;
};

/**
 * Same as `compareStartDate` but inverted.
 */
export const compareStartDateInverted = (
  a: CompareStartDateProps,
  b: CompareStartDateProps,
) => compareStartDate(a, b) * -1;
